export default "__VITE_ASSET__igmWvUMp__"